var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLastArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1213,
    height: 644,
    viewBox: "0 0 1213 644",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1124.5 397.5L1182 397.5C1198.57 397.5 1212 384.069 1212 367.5V31C1212 14.4314 1198.57 1 1182 1H1174",
    stroke: "#D94F56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1124 438.5L1182.5 438.5C1199.07 438.5 1212.5 425.069 1212.5 408.5V291",
    stroke: "#D94F56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1126 521.5L1182.5 521.5C1199.07 521.5 1212.5 508.069 1212.5 491.5V297",
    stroke: "#D94F56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1126 601L1182 601C1198.57 601 1212 587.568 1212 571V297",
    stroke: "#D94F56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1126 479L1182 479C1198.57 479 1212 465.568 1212 449V297",
    stroke: "#D94F56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M818 562H749C732.431 562 719 548.569 719 532V239.5C719 222.931 705.569 209.5 689 209.5H78C61.4315 209.5 48 196.069 48 179.5V32C48 15.4315 34.5685 2 18 2H0",
    stroke: "#D94F56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M817.5 643.5L767 643.5C750.432 643.5 737.001 630.069 737.001 613.5V32C737.001 15.4314 723.569 2 707.001 2H588",
    stroke: "#4E5055"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastArrows);
export default __webpack_public_path__ + "static/media/last-arrows.edc41e88424d4d31af5d7413b0661934.svg";
export { ForwardRef as ReactComponent };